export const notify = {
    methods: {
        hover: function(index) {
            let notif = this.notifications[index];

            if (notif.viewed || !notif.hashed_id) return

            this.notifications[index].viewed = '3242';


            axios.get(`/notifications/${notif.hashed_id}`).then(response => {
                if (response.data && response.data.unread_count) {
                    let data = response.data;

                    this.unread_count = (data.unread_count > 99) ? '99+' : data.unread_count;
                }
            });
        },
        on_notification_click: function(notif) {
            if (notif.action_url)
                window.location.href = notif.action_url;
        },
        process_notifications: function() {
            this.notifications.map((n) => {
                n.short_desc = this.process_desc(n.short_desc);
            });
        },
        process_desc: function(desc) {
            const re = /((\B|^)@[a-zA-Z0-9]+)|((\B|^)#[a-zA-Z0-9]+)|((\B|^)\*[a-zA-Z0-9]+)/g;

            return desc.replace(re, function(value) { return '<span class="tw-text-theme-primary">' + value + '</span>'; });
        },
    }
}
